import {SectionAboutComponent} from "./section-about/section-about.component";
import {SectionInstructionsComponent} from "./section-instructions/section-instructions.component";
import {SectionPropertyComponent} from "./section-property/section-property.component";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {DashboardComponent} from "./dashboard.component";
import {NgModule} from "@angular/core";
import { SectionStartComponent } from './section-start/section-start.component';
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {CarouselModule} from "primeng/carousel";
import {RcSearchPropertyComponent} from "./rc-search-property/rc-search-property.component";
import {DropdownModule} from "primeng/dropdown";
import {SliderModule} from "primeng/slider";
import {FormsModule} from "@angular/forms";
import {DialogModule} from "primeng/dialog";
import {GoogleMapsModule} from "@angular/google-maps";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {PropertyCardComponent} from "../../shared/components/property-card/property-card.component";

@NgModule({
    declarations: [
        SectionStartComponent,
        SectionAboutComponent,
        SectionInstructionsComponent,
        SectionPropertyComponent,
        RcSearchPropertyComponent
    ],
    exports: [
        SectionStartComponent,
        SectionAboutComponent,
        SectionInstructionsComponent,
        SectionPropertyComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([{path: '', component: DashboardComponent}]),
        ButtonModule,
        RippleModule,
        CarouselModule,
        DropdownModule,
        SliderModule,
        FormsModule,
        DialogModule,
        GoogleMapsModule,
        ProgressSpinnerModule,
        PropertyCardComponent
    ]
})
export class DashboardModule { }
